import React, { createContext, PropsWithChildren, useContext } from 'react';
import { BaseGlobalContextValue } from '~/providers/base-global-context/base-global.context';
import invariant from 'ts-invariant';
import { isFunction } from 'lodash';

interface Props<T extends BaseGlobalContextValue> {
    global: T;
}

export const GlobalContext = createContext<BaseGlobalContextValue>(null);

export function GlobalContextProvider<T extends BaseGlobalContextValue>({
    children,
    global
}: PropsWithChildren<Props<T>>) {
    return (
        <GlobalContext.Provider value={global}>
            {children}
        </GlobalContext.Provider>
    );
}

export function useGlobal<T extends BaseGlobalContextValue>(
    globalType: Function
): T {
    const globalContext = useContext(GlobalContext) as T;

    invariant(
        globalContext instanceof globalType, // This check may be not efficient, from what I checked its ok to use here because the tree of inheritance is short. If there are issues should check this line
        globalContext && isFunction(globalContext)
            ? `${globalType.name} was used inside ${globalContext.name}. Please use the right global context provider of ${globalType.name}.`
            : `${globalType.name} was used under no provider. Please provide the right global context provider.`
    );

    return globalContext;
}
